import Model from 'model-fns';
import Store from 'pull-store';
var model = Model('ottChannelID');
import Ev from '../../lib/event';
import xtend from 'xtend';
import Request from '../lib/requests';
import S from 'pull-stream';
import _ from 'underscore';
var r = {
    prop: require('ramda/src/prop'),
    curry: require('ramda/src/curry'),
    apply: require('ramda/src/apply')
};

function Channels () {
    return xtend(model(), {
        deleteModalOpen: false,
        pendingDeleteID: null,
        crudMessages: []
    });
}

Channels.effects = function (api) {
    var effects = {
        delete: function (state, ev) {
            return _.compose(
                Request.sandwich('delete'),
                Request.fromCallback(
                    _.compose(S.once, Ev('pushError')),  // onErr
                    function onSuccess (resp) {
                        return S.values([
                            Ev('delete', resp.data),
                            Ev('closeDeleteModal', null),
                            Ev('pushMessage', {
                                type: 'success',
                                message: 'Channel "' +
                                    state.data[state.pendingDeleteID]
                                        .channelName +
                                    '" has been deleted'
                            })
                        ]);
                    }
                ),
                r.curry(api.ott.delete)
            )({ ottChannelID: state.pendingDeleteID });
        }
    };

    // we need to call this with a join after
    return r.apply(function mapToEffect (state, ev) {
        var fn = effects[Ev.type(ev)];
        if (fn) return fn(state, Ev.data(ev));
        return S.once(ev);
    });
};

Channels.update = xtend(model.update, {
    openDeleteModal: function (state, ev) {
        return xtend(state, {
            deleteModalOpen: true,
            pendingDeleteID: ev
        });
    },

    closeDeleteModal: function (state, ev) {
        return xtend(state, {
            deleteModalOpen: false,
            pendingDeleteID: null
        });
    },

    pushMessage: function (state, ev) {
        return xtend(state, {
            crudMessages: state.crudMessages.concat([ev])
        });
    },

    shiftMessage: function (state, ev) {
        return xtend(state, {
            crudMessages: state.crudMessages.slice(1)
        });
    }
});

Channels.store = function () {
    return Store(function (state, ev) {
        return Channels.update[Ev.type(ev)](state, Ev.data(ev));
    }, Channels());
};

export default Channels;
